import { render, staticRenderFns } from "./Bbm.vue?vue&type=template&id=5780db82&scoped=true"
import script from "./Bbm.vue?vue&type=script&lang=js"
export * from "./Bbm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5780db82",
  null
  
)

export default component.exports